export const searchKeyword = (data, keyword, type) => {
    let tempData = [];
    let arr1 = [];
    let arr2 = [];
    let arr3 = [];
    let arr4 = [];
    let searchRegex = new RegExp(keyword, 'i');
    for (let key in data) {
        let item = data[key];
        let codeTemp = item['code']
        let typeTemp = type == 'airline' ? item['airline'] : item['airport']
        let keywordTemp = keyword
        if (type == 'en' || type == 'airline') {
            typeTemp = typeTemp.toLowerCase();
            keywordTemp = keywordTemp.toLowerCase();
        }
        if (searchRegex.test(codeTemp)) {
            tempData.push(item);
            if (codeTemp.toLowerCase().indexOf(keywordTemp) === 0) {
                arr1 = [];
                for (let i in tempData) {
                    let itemTemp = tempData[i]
                    let code = itemTemp['code'];
                    if (code.toLowerCase().indexOf(keywordTemp) === 0) {
                        arr1.push(itemTemp);
                    }
                }
                if (searchRegex.test(typeTemp)) {
                    arr2 = [];
                    if (typeTemp.indexOf(keywordTemp) === 0) {
                        for (let i in arr1) {
                            let itemTemp = arr1[i]
                            let code = type == 'airline' ? item['airline'] : item['airport'];
                            if (type == 'en' || type == 'airline') {
                                code = code.toLowerCase();
                            }
                            if (code.toLowerCase().indexOf(keywordTemp) === 0) {
                                arr2.unshift(itemTemp);
                            } else {
                                arr2.push(itemTemp);
                            }
                        }
                    }
                }
            }
        } else {
            // 搜airport
            if (searchRegex.test(typeTemp)) {
                arr3.push(item);
                if (typeTemp.indexOf(keywordTemp) === 0) {
                    arr4 = [];
                    for (let i in arr3) {
                        let itemTemp = arr3[i]
                        let code = type == 'airline' ? item['airline'] : item['airport']
                        if (type == 'en' || type == 'airline') {
                            code = code.toLowerCase();
                        }
                        if (code.indexOf(keywordTemp) === 0) {
                            arr4.unshift(itemTemp);
                        } else {
                            arr4.push(itemTemp);
                        }
                    }
                }
            }
        }
    }
    if (arr2.length > 0) {
        return arr2;
    }
    if (arr1.length > 0) {
        return arr1;
    }
    if (tempData.length > 0) {
        return tempData;
    }
    if (arr4.length > 0) {
        return arr4;
    }
    if (arr3.length > 0) {
        return arr3;
    }
    return data;
}

export const changeTimeByTimezone = (timezone) => {
    let TimeZone = timezone / 3600;
    // let tempValue = parseInt(longitude / 15)
    // let yushu = Math.abs(longitude % 15)
    // if (yushu <= 7.5) {
    // TimeZone = tempValue
    // } else {
    // TimeZone = tempValue + (longitude > 0 ? 1 : -1)
    // }
    TimeZone = TimeZone >= 0 ? "+" + Math.abs(TimeZone) : "-" + Math.abs(TimeZone)
    let now = new Date()
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    let date = now.getDate()
    let hours = now.getHours()
    let minutes = now.getMinutes()
    let seconds = now.getSeconds()
    let nowTimeZone = -(now.getTimezoneOffset() / 60)
    let d31 = [1, 3, 5, 7, 8, 10, 12]
    let d30 = [4, 6, 9, 11]
    // 当地时间换算成时区时间
    let localHours = hours - (nowTimeZone - TimeZone)
    if (localHours < 0) {
    localHours = localHours + 24
    if (date === 1 ) {
        if (month === 1) {
            year = year - 1
            month = 12
            date = 31
            } else {
            month = month - 1
            if (d31.indexOf(month) !== -1) {
                date = 31
            } else if (d30.indexOf(month) !== -1) {
                date = 30
            } else {
                // 2月份
                if (year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)) {
                date = 29
                } else {
                date = 28
                }
            }
            }
        } else {
            date = date - 1
        }
    }

    if (localHours >= 24) {
        localHours = localHours - 24
        if (date === 31) {
            if (month === 12) {
            year = year + 1
            month = 1
            } else {
            month = month + 1
            }
            date = 1
        } else if (date === 30) {
            if (d31.indexOf(month) === -1) {
            month = month + 1
            date = 1
            } else {
            date = date + 1
            }
        } else if (date === 29) {
            if (month === 2) {
            month = month + 1
            date = 1
            } else {
            date = date + 1
            }
        } else if (date === 28) {
            if (month === 2 && !(year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0))) {
            month = month + 1
            date = 1
            } else {
            date = date + 1
            }
        } else {
            date = date + 1
        }
    }
    return `${year}/${month}/${date} ${localHours}:${minutes}:${seconds}`
}